module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-04-32b532d9f4e2ccb88fa60ae4ab812adb.jpg";